import { schema } from 'normalizr';
import { createAction } from 'redux-api-middleware';
import { handleResponse, handleError } from '../utils';

export const FETCH_FOREX_REQUEST = 'FETCH_FOREX_REQUEST';
export const FETCH_FOREX_SUCCESS = 'FETCH_FOREX_SUCCESS';
export const FETCH_FOREX_FAILURE = 'FETCH_FOREX_FAILURE';

export const forexSchema = new schema.Entity(
  'forex',
  {},
  {
    idAttribute: 'date',
    processStrategy(forex) {
      return {
        ...forex,
      };
    },
  },
);

export const fetchForex = (month, year) =>
  createAction({
    endpoint: `${window.config.apiUrl}/forex/${month}-${year}`,
    method: 'GET',
    types: [
      { type: FETCH_FOREX_REQUEST },
      {
        type: FETCH_FOREX_SUCCESS,
        payload: (action, state, res) => handleResponse(forexSchema, action, state, res),
      },
      { type: FETCH_FOREX_FAILURE, payload: handleError },
    ],
  });
